import React, { useState, useEffect } from "react";
import { Layout, Tabs, Modal, Typography } from "antd";
import { useParams, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import Details from "./Details";
import FollowUp from "./FollowUp";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import AnimationWrapper from "../../../components/animations/AnimationWrapper";
import { unsavedChangesConfirmMessage } from "../../../components/forms/formsFeedback";
import PatientLogs from "../../logs/PatientLogs";
import NavigationPrompt from "react-router-navigation-prompt";
import CrmTemplate from "../../../components/crm/CrmTemplate";
import { loadRecord, reset } from "../../patientDetails/patientDetailsSlice";
import PatientDocuments from "../../patientDocuments";
import Absences from "../../patient/Absences";
import PatientPersonalFile from "../../patientPersonalFile";
import Orders from "../../orders";
import HouseVisits from "../../houseVisits";
import WorkDiaries from "../../workDiaries";
import Scheduling from "../../scheduling";
import { usePermission } from "../../../hooks/accessControl";
const { Text } = Typography;

const PatientDetails = (props) => {
  let { branchId, id } = useParams();
  const dispatch = useDispatch();
  let location = useLocation();
  const [activeTab, setActiveTab] = useState("followUp");

  const hasChanges = useSelector(
    (state) => state.patientDetails.changedItems.changed.length > 0
  );
  const intl = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    getPatient();
    return function cleanup() {
      dispatch(reset());
    };
  }, [dispatch]);

  const getPatient = () => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
      fromCrm: true,
    };
    dispatch(loadRecord(params));
  };
  const hasAssetsPermission = usePermission(branchId, "assets", "viewer");

  const components = [
    {
      key: "followUp",
      titleId: "app.opportunities.followUp",
      comp: <FollowUp hasAssetsPermission={hasAssetsPermission} />,
    },
    {
      key: "details",
      titleId: "app.opportunities.details",
      comp: <Details />,
    },
    {
      key: "absences",
      titleId: "app.opportunities.absences",
      comp: <Absences nonActive={true} />,
    },
    {
      key: "documentation",
      titleId: "app.opportunities.personal_file",
      comp: <PatientPersonalFile />,
    },
    {
      key: "service_orders",
      titleId: "app.opportunities.service_orders",
      comp: <Orders />,
    },
    {
      key: "scheduling",
      titleId: "app.opportunities.scheduling",
      comp: (
        <div style={{ height: "100%", display: "flex" }}>
          <Scheduling activeTab={activeTab} nonActive={true} />
        </div>
      ),
    },

    {
      key: "work_diary",
      titleId: "app.opportunities.work_diary",
      comp: <WorkDiaries nonActive={true} />,
    },
    {
      key: "house_visits",
      titleId: "app.opportunities.house_visits",
      comp: <HouseVisits nonActive={true} />,
    },
  ];

  if (hasAssetsPermission) {
    components.push({
      key: "documents",
      titleId: "app.patients.documents",
      comp: <PatientDocuments fromCrm={true} />,
    });
  }

  components.push({
    key: "logs",
    titleId: "app.patients.logs",
    comp: <PatientLogs activeTab={activeTab} />,
  });

  const navigateAndLoad = async (key, params) => {
    setActiveTab(key);
    // dispatch(loadRecord(params));
  };

  const onChange = async (key) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
    };

    if (hasChanges) {
      await unsavedChangesConfirmMessage({
        intl,
        onOk: () => {
          navigateAndLoad(key, params);
        },
        onCancel: () => {},
        modal,
      });
      return;
    }
    navigateAndLoad(key, params);
  };

  return (
    <CrmTemplate hasTabs={true}>
      <Layout style={{ height: "100%" }}>
        <NavigationPrompt when={hasChanges}>
          {({ onConfirm, onCancel }) => {
            return (
              <Modal
                title={intl.formatMessage({
                  id: "app.forms.unSavedChangesTitle",
                })}
                open={true}
                onOk={() => {
                  onConfirm();
                }}
                onCancel={onCancel}
                okText={intl.formatMessage({
                  id: "app.forms.unSavedChangesOkText",
                })}
                cancelText={intl.formatMessage({
                  id: "app.forms.unSavedChangesCancelText",
                })}
              >
                <Text>
                  {intl.formatMessage({
                    id: "app.forms.unSavedChangesContent",
                  })}
                </Text>
              </Modal>
            );
          }}
        </NavigationPrompt>
        {contextHolder}
        <Tabs
          defaultActiveKey="followUp"
          activeKey={activeTab}
          style={{}}
          onChange={onChange}
          destroyInactiveTabPane={true}
          items={components.map((option) =>
            !option.hide
              ? {
                  label: <FormattedMessage id={option.titleId} />,
                  key: option.key,
                  children: <>{option.comp}</>,
                }
              : null
          )}
        />
      </Layout>
    </CrmTemplate>
  );
};

PatientDetails.propTypes = {
  mode: PropTypes.string,
};

export default PatientDetails;
